import React, { useState } from "react";
import PropTypes from 'prop-types';
import '../styles/secdevtool.css';

const UnixTimestamp = () => {
  const [secondsOutput, setSecondsOutput] = useState('');
  const [output, setOutput] = useState('');
  const [isConvertVisible, setConvertVisible] = useState(true);
  const [currentTime, setCurrentTime] = useState('');
  const [currentSeconds, setCurrentSeconds] = useState('');

  // convert to Seconds
  const convertToSeconds = () => {
    let year = document.getElementById('year').value;
    let month = document.getElementById('month').value;
    let day = document.getElementById('day').value;
    let hours = document.getElementById('hours').value;
    let minutes = document.getElementById('minutes').value;
    let seconds = document.getElementById('seconds').value;

    if (year === '' || parseInt(year) < 1970 || isNaN(parseInt(year))) {
      document.getElementById('error').innerHTML = 'Please enter a valid year greater than or equal to 1970.';
      return;
    }

    if (parseInt(month) < 1 || parseInt(month) > 12 || isNaN(parseInt(month))) {
      document.getElementById('error').innerHTML = 'Month must be between 1 and 12.';
      return;
    }

    // Helper function to validate if a string is a valid number
    const isValidNumber = (value) => /^\d+$/.test(value.trim());

    // Convert inputs to numbers safely
    const yearNum = parseInt(year.trim());
    const monthNum = parseInt(month.trim());
    const dayNum = parseInt(day.trim());
    const hoursNum = parseInt(hours.trim());
    const minutesNum = parseInt(minutes.trim());
    const secondsNum = parseInt(seconds.trim());

    // Year validation
    if (!isValidNumber(year) || yearNum < 1970) {
      document.getElementById('error').innerHTML = 'Please enter a valid year (1970 or later).';
      return;
    }

    // Month validation
    if (!isValidNumber(month) || monthNum < 1 || monthNum > 12) {
      document.getElementById('error').innerHTML = 'Please enter a valid month (1-12).';
      return;
    }

    // Day validation based on the month
    if (monthNum === 2) {
      const isLeapYear = (yearNum % 4 === 0 && yearNum % 100 !== 0) || (yearNum % 400 === 0);
      if (!isValidNumber(day) || dayNum < 1 || (!isLeapYear && dayNum > 28) || (isLeapYear && dayNum > 29)) {
        document.getElementById('error').innerHTML = isLeapYear
            ? 'Day must be between 1 and 29 (leap year).'
            : 'Day must be between 1 and 28.';
        return;
      }
    } else if ([4, 6, 9, 11].includes(monthNum)) {
      if (!isValidNumber(day) || dayNum < 1 || dayNum > 30) {
        document.getElementById('error').innerHTML = 'Day must be between 1 and 30.';
        return;
      }
    } else {
      if (!isValidNumber(day) || dayNum < 1 || dayNum > 31) {
        document.getElementById('error').innerHTML = 'Day must be between 1 and 31.';
        return;
      }
    }

    // Hours validation
    if (!isValidNumber(hours) || hoursNum < 0 || hoursNum > 23) {
      document.getElementById('error').innerHTML = 'Hours must be between 0 and 23.';
      return;
    }

    // Minutes validation
    if (!isValidNumber(minutes) || minutesNum < 0 || minutesNum > 59) {
      document.getElementById('error').innerHTML = 'Minutes must be between 0 and 59.';
      return;
    }

    // Seconds validation
    if (!isValidNumber(seconds) || secondsNum < 0 || secondsNum > 59) {
      document.getElementById('error').innerHTML = 'Seconds must be between 0 and 59.';
      return;
    }

    // If all validations pass, calculate the timestamp
    let date = new Date(Date.UTC(yearNum, monthNum - 1, dayNum, hoursNum, minutesNum, secondsNum));
    let timestamp = Math.floor(date.getTime() / 1000);
    setSecondsOutput(timestamp.toString());

  };

  // convert to Date
  const convertToDate = () => {
    let secondsInput = document.getElementById('secondsInput').value;

    // Überprüfung der Eingabe
    if (secondsInput === '' || parseInt(secondsInput) < 0 || isNaN(parseInt(secondsInput))) {
      document.getElementById('error2').innerHTML = 'Please enter a valid positive number of seconds.';
      return;
    }

    let date = new Date(parseInt(secondsInput) * 1000);

    let options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      hour12: false,
      minute: 'numeric',
      second: 'numeric',
      timeZone: 'UTC'
    };

    let formattedDate = date.toLocaleString('en-US', options);
    setOutput(formattedDate);
  };

  //get current Timestamp
  const getCurrentTimestamp = () => {
    let currentDate = new Date();
    let timestamp = Math.floor(currentDate.getTime() / 1000);
    setCurrentTime(timestamp.toString());
    setCurrentSeconds(currentDate.toString());
    document.getElementById('currentSeconds').value = timestamp;
  };

  // Toggle between encoder and decoder sections
  const converterButton = () => {
    setConvertVisible(true);
    handleResetButtonClick();
  };

  const timestampButton = () => {
    setConvertVisible(false);
    handleResetButtonClick();
  };

  const handleResetButtonClick = () => {

    setSecondsOutput('');
    setOutput('');
    setCurrentTime('');
    setCurrentSeconds('');

    const yearElement = document.getElementById('year');
    const monthElement = document.getElementById('month');
    const dayElement = document.getElementById('day');
    const hoursElement = document.getElementById('hours');
    const minutesElement = document.getElementById('minutes');
    const secondsElement = document.getElementById('seconds');
    const errorElement = document.getElementById('error'); // Fehlermeldung
    const error2Element = document.getElementById('error2');
    const secondsInputElement = document.getElementById('secondsInput');

    if (yearElement) yearElement.value = '';
    if (monthElement) monthElement.value = '';
    if (dayElement) dayElement.value = '';
    if (hoursElement) hoursElement.value = '';
    if (minutesElement) minutesElement.value = '';
    if (secondsElement) secondsElement.value = '';
    if (secondsInputElement) secondsInputElement.value = '';

    // Fehlermeldung löschen
    if (errorElement) errorElement.innerHTML = '';
    if (error2Element) error2Element.innerHTML = '';
  };

  return (
      <main>
        <div className="container mt-4">
          {/* Header Section */}
          <section aria-labelledby="timestamp-header">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h2 id="timestamp-header" className="mb-0">Timestamp</h2>
              <div className="d-flex align-items-center">
                <button
                    type="button"
                    onClick={handleResetButtonClick}
                    className="btn text-dark btn-outline-danger rounded ms-3 me-3 p-2 reset-btn-timestamp"
                >
                  Reset
                </button>
                <nav aria-label="Page navigation">
                  <ul className="pagination mb-0">
                    <li
                        className={`page-item border p-2 roundedBtnLeft ${isConvertVisible ? 'active' : ''}`}
                        onClick={converterButton}
                    >
                      Converter
                    </li>
                    <li
                        className={`page-item border p-2 roundedBtnRight ${!isConvertVisible ? 'active' : ''}`}
                        onClick={timestampButton}
                    >
                      Timestamp
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </section>

          {/* Converter Section */}
          {isConvertVisible ? (
              <section aria-labelledby="converter-section">
                <h3 id="converter-section">Converter</h3>
                <div className="emailBg p-4">
                  <div className="table-responsive">
                    <table className="tableBg table">
                      <thead>
                      <tr>
                        <th><label htmlFor="year">Year:</label></th>
                        <th><label htmlFor="month">Month:</label></th>
                        <th><label htmlFor="day">Day:</label></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td><input type="text" id="year" placeholder="YYYY" className="form-control" /></td>
                        <td><input type="text" id="month" placeholder="MM" className="form-control" /></td>
                        <td><input type="text" id="day" placeholder="DD" className="form-control" /></td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                      <tr>
                        <th><label htmlFor="hours">Hours (24):</label></th>
                        <th><label htmlFor="minutes">Minutes:</label></th>
                        <th><label htmlFor="seconds">Seconds:</label></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr>
                        <td><input type="text" id="hours" placeholder="HH" className="form-control" /></td>
                        <td><input type="text" id="minutes" placeholder="MM" className="form-control" /></td>
                        <td><input type="text" id="seconds" placeholder="SS" className="form-control" /></td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                  <h4>Result</h4>
                  <div id="error"></div>
                  <textarea
                      className="form-control w-100 mt-3"
                      value={secondsOutput}
                      placeholder="Converted result"
                      readOnly
                  ></textarea>
                  <button
                      type="button"
                      onClick={convertToSeconds}
                      className="btn btn-secondary rounded mt-3"
                  >
                    Convert to Seconds
                  </button>

                  <h4 className="mt-4">Convert seconds to date and time</h4>
                  <div id="error2"></div>
                  <input className="form-control w-100 mt-3" type="number" id="secondsInput" placeholder="Enter seconds" />
                  <button
                      type="button"
                      onClick={convertToDate}
                      className="btn btn-secondary mt-4"
                  >
                    Convert to Date
                  </button>
                  <textarea
                      className="form-control w-100 mt-4"
                      value={output}
                      placeholder="Result"
                      readOnly
                  ></textarea>
                </div>
              </section>
          ) : (
              <TimestampSection
                  getCurrentTimestamp={getCurrentTimestamp}
                  currentTime={currentTime}
                  currentSeconds={currentSeconds}
              />
          )}
        </div>
      </main>
  );
};

const TimestampSection = ({ getCurrentTimestamp, currentTime, currentSeconds }) => {
  return (
      <div>
        <div className="mt-3">
          <h3 className="mb-3">Current timestamp</h3>
          <div className="row">
            <div className="col-md-6 mb-2">
              <textarea className="form-control" id="currentTime" placeholder="Press the button below to see the timestamp" aria-label="Current timestamp" name="currentTime" rows="3" readOnly value={currentTime}></textarea>
            </div>
            <div className="col-md-6">
              <textarea className="form-control" id="currentSeconds" placeholder="Date and time of the timestamp" aria-label="Current date" name="currentSeconds" rows="3" readOnly value={currentSeconds}></textarea>
            </div>
          </div>
          <input type="button" value="Get timestamp" onClick={getCurrentTimestamp} className="btn btn-secondary mt-2" />
        </div>
      </div>
  );
};

// Prop-Typen-Validierung für TimestampSection hinzufügen
TimestampSection.propTypes = {
  getCurrentTimestamp: PropTypes.func.isRequired,
  currentTime: PropTypes.string.isRequired,
  currentSeconds: PropTypes.string.isRequired
};

export default UnixTimestamp;